export const GAP = 8;

export const MIN_VISIBLE_TAGS = 1;

export const FONT_TOLERANCE = 1;

export const TAG_EMAIL_TOOLTIP_MAXWIDTH = 350;
